import styled from 'styled-components';

interface MenuPopupProps {
  isOpen?: boolean;
  collapsed?: boolean;
  children: any;
}

const StyledMenuPopup = styled.div<{ $isOpen?: boolean; $collapsed?: boolean }>`
  // Tipo exclusivo para $isOpen
  font-size: 1.75vh;
  position: absolute;
  min-width: ${({ $collapsed }) => ($collapsed ? '220px' : '260px')};
  width: ${({ $collapsed }) => ($collapsed ? '220px' : 'auto')};
  top: 80%;
  left: 1%;
  background-color: #f9f9f9;
  color: black;
  padding: 5px;
  gap: 10px;
  border-radius: 10px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 2;
  display: ${({ $isOpen }) =>
    $isOpen ? 'grid' : 'none'}; // Controla a exibição com base no estado isOpen
  grid-template-columns: auto;
  align-content: middle;
  transform: translateY(-50%);

  &::before {
    content: '';
    position: absolute;
    top: ${({ $collapsed }) => ($collapsed ? '50%' : '99%')};
    left: ${({ $collapsed }) => ($collapsed ? '0' : '50%')};
    transform: translateX(-50%);
    border-style: solid;
    border-width: 10px 10px 0 10px;
    border-color: #fff transparent transparent transparent;
  }

  a {
    padding: 0.25rem;
  }

  a:hover {
    background-color: #cecece;
    border-radius: 5px;
  }
`;

export default function MenuPopup(props: MenuPopupProps) {
  return (
    <>
      {}
      <StyledMenuPopup $isOpen={props.isOpen} $collapsed={props.collapsed}>
        {props.children}
      </StyledMenuPopup>
    </>
  );
}
